export default {
  name: '',
  shiftType: 'weekly',
  workHolidays: false,
  lunchCheck: false,
  lunchTime: '',
  startLunch: '',
  endLunch: '',
  tolerance: '',
  shiftDaysAttributes: [],
  startDate: '',
  contractIds: [],
  contracts: []
};
